export const RECEIVE_STATEMENT_FIELD = "receiveStatement";
export const STATEMENT_PERIODICITY_FIELD = "statementPeriodicity";
